import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import Toolbar from "@material-ui/core/Toolbar";
import { withRouter } from "react-router";
import PropTypes from "prop-types";
import Sticky from "react-stickynode";

import { Heading4 } from "../styleguide";
import scrollStop from "../utils/scrollStop";
import { HEADER_HEIGHT } from "../layouts/Header";
import { NAVIGATION_HEIGHT } from "../layouts/Navigation";

export const SUMMARY_BAR_BORDER_WIDTH = 4;
export const SUMMARY_BAR_HEIGHT = 44;

const styles = (theme) => ({
    contentWrapperStyle: {
        display: "flex",
        flex: "1 0 auto",
        marginLeft: "auto",
        marginRight: "auto",
        maxWidth: 1200,
        width: "100%",
    },
    containerStyle: {
        top: HEADER_HEIGHT + NAVIGATION_HEIGHT,
        zIndex: 2,
        backgroundColor: "#fafafa",
    },
    toolbarRootStyle: {
        padding: "0 36px",
        minHeight: SUMMARY_BAR_HEIGHT,
        backgroundColor: "#f0f1f2",
        display: "flex",
        justifyContent: "start",
        alignItems: "stretch",
        boxShadow: "inset 0 2px 0 0 #D6D8DB",
    },
    summaryStyle: {
        display: "flex",
        paddingTop: 13,
        marginRight: 32,
        borderBottom: "4px solid transparent",
    },
    linkStyle: {
        textDecoration: "none",
        color: "inherit",
    },
    activeSummaryStyle: {
        borderBottom: `${SUMMARY_BAR_BORDER_WIDTH}px solid #303c49`,
    },
    headingStyle: {
        fontSize: theme.typography.pxToRem(15),
        lineHeight: 1.4,
    },
});

class SummaryBar extends Component {
    scrollStopListener = null;
    historyListener = null;

    constructor({ location: { hash } }) {
        super();
        this.state = { hash };
    }

    componentDidMount() {
        this.historyListener = this.props.history.listen(({ hash }) => this.setState({ hash }));
        // This is required, because no props are received when hash is empty, e.g., when scrolling to outside of the anchor containers
        this.scrollStopListener = scrollStop(() => {
            // Clear state if there is no hash
            if (!window.location.hash && this.state.hash) {
                this.setState({ hash: "" });
            }
        });
    }

    componentWillUnmount() {
        if (this.scrollStopListener) {
            this.scrollStopListener();
        }

        if (this.historyListener) {
            this.historyListener();
        }
    }

    renderSummaries = () => {
        const {
            sections,
            disabledMarker,
            classes: { summaryStyle, linkStyle, activeSummaryStyle, headingStyle },
        } = this.props;
        const { hash } = this.state;

        return sections.map(({ slug, headline }, index) => {
            const isSummaryActive = !disabledMarker && (hash === `#${slug}` || (hash === "" && index === 0));
            const summaryClassName = `${summaryStyle} ${isSummaryActive ? activeSummaryStyle : ""}`;

            return (
                <div key={slug} className={summaryClassName}>
                    <Heading4 className={headingStyle}>
                        <a
                            href={`#${slug}`}
                            className={linkStyle}
                            onClick={(e) => {
                                e.preventDefault();
                                window.location = `#${slug}`;
                            }}
                        >
                            {headline}
                        </a>
                    </Heading4>
                </div>
            );
        });
    };

    render() {
        const {
            classes: { contentWrapperStyle, containerStyle, toolbarRootStyle },
        } = this.props;

        return (
            <div className={containerStyle}>
                <Sticky top={HEADER_HEIGHT + NAVIGATION_HEIGHT} innerZ={2}>
                    <Toolbar classes={{ root: toolbarRootStyle }}>
                        <div className={contentWrapperStyle}>{this.renderSummaries()}</div>
                    </Toolbar>
                </Sticky>
            </div>
        );
    }
}

SummaryBar.propTypes = {
    sections: PropTypes.arrayOf(PropTypes.object).isRequired,
    classes: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    disabledMarker: PropTypes.bool,
};

export default withRouter(withStyles(styles)(SummaryBar));



// WEBPACK FOOTER //
// ./src/components/SummaryBar.js